import { DriverApi, Driver } from '../models';

export function mapDriverApiToDriver(driverApi: DriverApi): Driver {
  const schedules = (driverApi as any).schedules || driverApi.Schedules || [];

  return {
    id: driverApi.id,
    firstName: driverApi.name || '',
    lastName: driverApi.lastName || '',
    documentNumber: driverApi.documentNumber,
    email: driverApi.email || '',
    phone: driverApi.phone || '',
    costRange:
      (driverApi as any).costRange ??
      (driverApi as any).costRange ??
      (driverApi as any).cost_range,
    lastCost:
      (driverApi as any).lastCost ??
      (driverApi as any).lastCost ??
      (driverApi as any).last_cost ??
      null,
    company: driverApi.company || undefined,
    Schedules: schedules.map((schedule: any) => ({
      id: schedule.id,
      from: schedule.from,
      to: schedule.to,
      costModeId: schedule.costMode?.id ?? '',
      costMode: schedule.costMode
        ? {
            id: schedule.costMode.id,
            name: schedule.costMode.name,
            Costs: schedule.costMode?.Costs?.map((item: any) => ({
              id: item.id,
              amount: item.amount,
              validFrom: item.validFrom,
              validTo: item.validTo,
            })),
          }
        : undefined,
    })),
  };
}
